import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import { FeedLeftContent } from "../components/feed/FeedLeftContent";
import { FeedPosts } from "../components/feed/FeedPosts";
import { FeedRightContent } from "../components/feed/FeedRightContent";

export default function FeedPage() {
  return (
    <AuthenticatedLayout>
      <div className="px-4 sm:px-6 lg:px-8 py-8 md:py-0 w-full max-w-9xl mx-auto">
        <div className="xl:flex">
          {/* Left + Middle content */}
          <div className="md:flex flex-1">
            {/* Left content */}
            <FeedLeftContent />

            {/* Middle content */}
            <div className="flex-1 md:ml-8 xl:mx-4 2xl:mx-8">
              <div className="md:py-8">
                <FeedPosts />
              </div>
            </div>
          </div>

          {/* Right content */}
          <FeedRightContent />
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
